import { RESPONSE_TYPE } from "../const/vote";
import { IQuestionState } from "../domain/ballot-state";
import { ApiIQuestion } from "../domain/election";
import { PREFERENCE } from "./preference/preference-typedef";
import { BalllotReviewProps } from "./types";

export interface IReviewMuxProps extends BalllotReviewProps<any> {
    response_type: RESPONSE_TYPE
}

/**
 * Prepare Mux is called before the review screen
 * @param props 
 * @returns 
 */
export const prepareSubmitMux = (
    question: ApiIQuestion,
    questionState: IQuestionState
): any => {
    const { response_type } = question;

    switch (response_type) {
        case RESPONSE_TYPE.PREFERENCE:
            return PREFERENCE.prepareSubmit(question, questionState);
    }

    return questionState.value;
};
